import React, {Fragment} from 'react';
// import Select from 'react-select'
import {
    FormGroup,
    Input,
    Label,
    Row,
    Col,
    Button,
    Alert
} from 'reactstrap';
import CKEditor from 'ckeditor4-react';
import customConst from "../../../global";
import DatePickerComponent from "../../UI/Datepicker/Datepicker";
import {faTimesCircle, faPaperclip} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const editorConfig = customConst.editorConfig;

const myRef = React.createRef();
const EditDayForm = props => {

    const groupedOptions = []

    props.tourMetas.regions.map(region => {
        let options = []

        props.tourMetas.locations.map(location => {
            if (location.region === region.id) {
                options.push({value: location.id, label: location.title })
            }
        })

        let data = {
            label: region.title,
            options: options
        }
        groupedOptions.push(data)
    })

    const clearImage = () => {
        myRef.current.value = null;

        props.removeImageInDay()
    };

    return (
        props.tourMetas ?
            <Fragment>
                <Row>
                    <Col>
                        <DatePickerComponent
                            disabled={props.isCanEditDays}
                            dates={props.dates}
                            selected={props.day.date}
                            setDate={props.setDate}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <FormGroup>
                            <Label for='location_a'>Location A *</Label>
                            <Input
                                disabled={props.isCanEditDays}
                                type='select'
                                name='location_a'
                                value={props.day.location_a}
                                onChange={props.dayChange}
                            >
                                <option>Choose location A</option>
                                {props.tourMetas.regions.map(region => {
                                    return (
                                        <optgroup key={region.id} label={region.title}>
                                            {props.tourMetas.locations.map(location => {
                                                if (location.region === region.id) {
                                                    return (
                                                        <option value={location.id}
                                                                key={location.id}>{location.title}</option>
                                                    )
                                                }
                                            })}
                                        </optgroup>
                                    )
                                })}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>Location B *</Label>
                            <Input
                                disabled={props.isCanEditDays}
                                type='select'
                                onChange={props.dayChange}
                                name='location_b'
                                value={props.day.location_b}
                            >
                                <option>Choose location B</option>
                                {props.tourMetas.regions.map(region => {
                                    return (
                                        <optgroup key={region.id} label={region.title}>
                                            {props.tourMetas.locations.map(location => {
                                                if (location.region === region.id) {
                                                    return (
                                                        <option value={location.id}
                                                                key={location.id}>{location.title}</option>
                                                    )
                                                }
                                            })}
                                        </optgroup>
                                    )
                                })}
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Additional Locations</Label>

                            <select
                                name="additional_locations"
                                value={props.day.additional_locations}
                                multiple={true}
                                onChange={props.handleClickAdditionalLocations}
                                className={'form-control'}
                            >
                                {props.tourMetas.regions.map(region => {
                                    return (
                                        <optgroup key={region.id} label={region.title}>
                                            {props.tourMetas.locations.map(location => {
                                                if (location.region === region.id) {
                                                    return (
                                                        <option value={location.id}
                                                                key={location.id}>{location.title}</option>
                                                    )
                                                }
                                            })}
                                        </optgroup>
                                    )
                                })}
                            </select>
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Label for={'day_description_' + props.dayNum}>Description</Label>
                        <CKEditor
                            readOnly={props.disabled}
                            id={'day_description_' + props.dayNum}
                            type={editorConfig.type}
                            data={!props.day.description ? '' : props.day.description}
                            config={editorConfig}
                            onChange={props.ckEditorDayDescription}
                            name='description'
                        />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Label id={"day_remarks" + props.dayNum}>Remarks</Label>
                        <CKEditor
                            readOnly={props.disabled}
                            id={"day_remarks" + props.dayNum}
                            data={!props.day.remarks ? '' : props.day.remarks}
                            config={editorConfig}
                            onChange={props.ckEditorDayRemarks}
                            name='remarks'
                        />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Image</Label>
                            <div className="tour_attachment_wrapper">
                                {props.day.image && (props.day.image !== '' && props.day.image.length > 0) ?
                                    <a className="attach_link" href={props.day.image} target='_blank'><FontAwesomeIcon className="icon" icon={faPaperclip} /> View</a>
                                    : null
                                }
                                <Input type='file'
                                       disabled={props.disabled}
                                       name='image'
                                       onChange={props.dayFileChange}
                                       innerRef={myRef}
                                />
                                {props.day.image && (props.day.image !== '' && props.day.image.length > 0) ?
                                    !props.disabled ? <span className='remove-file' onClick={clearImage}><FontAwesomeIcon
                                        icon={faTimesCircle}/></span> : null
                                    : null
                                }
                            </div>

                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className="services_wrapper">
                            <Row>
                                <Col>
                                    <Label>Services</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {props.tourMetas.services.map((service, index) => {
                                        const servicesInDay = props.day.services;
                                        return (
                                            <div key={index} className="form-check form-check-inline">
                                                <Input type='checkbox'
                                                       disabled={props.disabled}
                                                       name={`service_${index + 1}_day_${props.dayNum}`}
                                                       id={`service_${index + 1}_day_${props.dayNum}`}
                                                       value={service.id}
                                                       onClick={props.handleClick}
                                                       defaultChecked={servicesInDay.includes(parseInt(service.id))}
                                                />
                                                <Label
                                                    for={`service_${index + 1}_day_${props.dayNum}`}>{service.title}</Label>
                                            </div>
                                        )
                                    })}
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>

                {props.isCanEditDays ? null : <Row>
                    <Col>
                        <Button onClick={props.removeDay} color='danger'>Remove day</Button>
                    </Col>
                </Row>}

                <div className="line_helper"></div>
            </Fragment> : null
    );
};

export default EditDayForm;
